<script setup>
import { ref, provide, onMounted } from "vue";
import { notification } from "@/plugins/notyf";
import { useRouter } from "vue-router";
const loading = ref(false);
provide("loading", loading);
const router = useRouter();
const props = defineProps({
  judul: {
    type: String,
  },
});
onMounted(() => {
  notification();
});
</script>
<style></style>

<template>
  <div class="flex flex-col min-h-screen overflow-x-clip">
    <header>
      <slot name="header" />
    </header>

    <main class="flex-1">
      <div class="max-w-screen-xl px-4 py-4 mx-auto">
        <slot name="default">
          <p>Default</p>
        </slot>
      </div>
    </main>

    <footer class="mt-auto">
      <slot name="footer" />
    </footer>
  </div>
</template>
